import { Link } from "react-router-dom";

export const AdminSignInLink = () => (
  <Link
    to="/retailer/login?as=admin"
    className="whitespace-nowrap text-xs text-slate-400 hover:text-[#2A5A3B] underline-offset-2 hover:underline transition-colors"
    data-testid="footer-admin-signin-link"
  >
    Admin sign in
  </Link>
);
